import { useMutation, useQuery } from 'react-query'

import { getAccessToken, getOrganizationId, getSpaceId } from '@/store/contextSubscriber'

export default function useNotificator() {
  const baseUrl = `/v2/publisher/organizations/${getOrganizationId()}/spaces/${getSpaceId()}/notificator`

  async function fetchMetadata() {
    const response = await fetch(`${baseUrl}/metadata`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    })
    return response.json()
  }

  async function submitNotifications(data: any) {
    const response = await fetch(`${baseUrl}/createJobs`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...data, type: 'notification.create' })
    })

    return response.json()
  }

  async function clearNotifications(data: any) {
    const response = await fetch(`${baseUrl}/createJobs`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...data, type: 'notification.delete' })
    })

    return response.json()
  }

  const metadata = useQuery({
    queryKey: ['notificator-cards-metadata', baseUrl],
    queryFn: () => fetchMetadata()
  })

  const submit = useMutation({
    mutationFn: submitNotifications
  })
  const clear = useMutation({
    mutationFn: clearNotifications
  })

  return {
    metadata,
    submit,
    clear
  }
}
